export const DownloadTracker = {
  STORAGE_KEY: "downloadCountTracker",

  getDownloadCounts(): Record<string, number> {
    try {
      return JSON.parse(localStorage.getItem(this.STORAGE_KEY) || "{}");
    } catch (e) {
      console.error("Failed to parse download counts:", e);
      return {};
    }
  },

  startNewDownload(url: string): number {
    const counts = this.getDownloadCounts();
    counts[url] = (counts[url] || 0) + 1;
    localStorage.setItem(this.STORAGE_KEY, JSON.stringify(counts));
    return counts[url];
  },

  getCurrentCount(url: string): number {
    const counts = this.getDownloadCounts();
    return counts[url] || 0;
  },
};
